import { NL } from "./nl_NL"

/**
 * Type representing all valid internationalization keys
 */
export type IntlKey = keyof typeof NL

export const isIntlKey = (key: unknown): key is IntlKey => typeof key === "string" && key in NL

/**
 * The platform's own "no practices found" copy on the public search page, one
 * key per paragraph in reading order. The public page renders these, and the
 * care group settings show them as the default a care group's own message
 * replaces, so both sides must agree on exactly this list.
 */
export const PLATFORM_NO_RESULTS_KEYS = [
  "practiceSearch.searchZipCode.noResults",
  "practiceSearch.searchZipCode.noResults.clarification",
] as const satisfies readonly IntlKey[]

/**
 * The platform's intro above the postal-code waiting-list form on the public
 * search page, shown when a practice in the results is closed for
 * registration. The public page renders it, and the care group settings show
 * it as the default a care group's own message replaces. Takes `postalCode`
 * and `br` as values.
 */
export const PLATFORM_CLOSED_PRACTICES_KEY = "postalCodeWaitingList.description" as const satisfies IntlKey
